import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import FocusLock from 'react-focus-lock';

import { PageSection } from '../../../ContentfulTypes';
import {
  CloseModalWrapper,
  Title,
  MainText,
  ButtonWrapper,
  NoButton,
  YesButton,
} from './styles';

interface CloseModalProps {
  clickHandlerNo: () => void,
  clickHandlerYes: () => void,
  reserveData: PageSection
}

const CloseModal = ({ clickHandlerNo, clickHandlerYes, reserveData }: CloseModalProps) => {
  const modalLabels = reserveData.formFields?.reduce<Record<string, string | undefined>>(
    (obj, item) => {
      obj[item.contentful_id] = item.displayLabel;
      return obj;
    },
    {},
  ) || {};
  
  return (
    <CloseModalWrapper>
      <FocusLock>
        <Title>{ReactHtmlParser(modalLabels['2qg1eE1NDZFk9Qn5qRRRxs'])}</Title>
        <hr />
        <MainText>
          {ReactHtmlParser(modalLabels['64CB2SVkCVDuRr0WvXWnsf'])}
        </MainText>
        <ButtonWrapper>
          <YesButton onClick={clickHandlerYes}>
            {ReactHtmlParser(modalLabels.fO7wiocJuoBnKsQmPhrsy)}
          </YesButton>
          <NoButton onClick={clickHandlerNo}>
            {ReactHtmlParser(modalLabels['7sOH7MLsraU7YaFJ31Jnic'])}
          </NoButton>
        </ButtonWrapper>
      </FocusLock>
    </CloseModalWrapper>
  );
};

export default CloseModal;
